import { useFormikContext } from "formik";

import Spinner from "shared/components/common/Spinner";
import PillarModalBody, {
  type PillarModalBodyProps,
} from "shared/components/pillar-modal/NewPillarModalBody";

type PillarFormSubmittingModalProps = Omit<
  PillarModalBodyProps<false>,
  "control"
>;

const PillarFormSubmittingModal = ({
  children,
  testid,
  ...props
}: PillarFormSubmittingModalProps) => {
  const { isSubmitting } = useFormikContext();

  return (
    <PillarModalBody
      control={{
        isOpen: isSubmitting,
      }}
      testid={testid}
      {...props}
    >
      {children}
      <Spinner testid={testid ? `${testid}-spinner` : undefined} />
    </PillarModalBody>
  );
};

export default PillarFormSubmittingModal;
